import { noteInvalid } from '../../../grid-components/panel-validation';
import { ReleasableHoldReasons } from '../bill-management-types';

export const releaseInvalid = (
  note: string,
  selectedHoldType: string | undefined,
  releasedToClientInsurerId?: number,
  releasedToContractId?: number,
): boolean => {
  if (noteInvalid(note)) return true;
  if (selectedHoldType === ReleasableHoldReasons.MANUAL_HOLD) return false;
  if (typeof releasedToClientInsurerId !== 'number') return true;
  if (
    (selectedHoldType === ReleasableHoldReasons.CARRIER_CHANGE ||
      selectedHoldType === ReleasableHoldReasons.CLIENT_CHANGE) &&
    typeof releasedToContractId !== 'number'
  )
    return true;
  return false;
};
